// extracted by mini-css-extract-plugin
export default {"header":"header_header__lOwdN","title":"header_title__hT60b","subtitle":"header_subtitle__VyH1n"};